import { FC, useMemo } from 'react'

import { BlockProps } from '../props'
import SectionWrapper from '../../../components/SectionWrapper'
import { ImageTransformer } from '../../Transformers/ImageTransformer'
import HomePageAccountCreationCard, {
  HomePageAccountCreationCardProps,
} from '../../../components/HomePageAccountCreationCard'

import { ImageRightTextLinkLeftProps } from './props'

const ImageRightTextLinkLeft: FC<BlockProps<ImageRightTextLinkLeftProps>> = ({
  data,
}) => {
  const props: HomePageAccountCreationCardProps = useMemo(
    () => ({
      image: ImageTransformer(data?.image),
      title: data?.title,
      description: data?.description,
      button: {
        label: data?.link?.text,
        href: data?.link?.href,
        variant: data?.link?.variant,
        title: data?.link?.title,
        target: data?.link?.target,
      },
    }),
    [data]
  )

  return (
    <SectionWrapper spacing="medium" withBackgroundColor>
      <HomePageAccountCreationCard {...props} />
    </SectionWrapper>
  )
}
export default ImageRightTextLinkLeft
